var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1728,
    height: 1728,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1031.25 43.25c5.94-5.937 5.94-15.563 0-21.5-5.94-5.937-15.56-5.937-21.5 0-5.94 5.937-5.94 15.563 0 21.5 5.94 5.937 15.56 5.937 21.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1028.02 39.739c4.15-4.154 4.15-10.889 0-15.043a10.646 10.646 0 0 0-15.05 0c-4.15 4.154-4.15 10.889 0 15.043a10.646 10.646 0 0 0 15.05 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1231.5 612.5c5.25-5.247 5.25-13.753 0-19s-13.75-5.247-19 0-5.25 13.753 0 19 13.75 5.247 19 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1228.64 609.397c3.67-3.671 3.67-9.623 0-13.293a9.396 9.396 0 0 0-13.29 0c-3.67 3.67-3.67 9.622 0 13.293a9.396 9.396 0 0 0 13.29 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1163.5 620.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1162.15 619.03a4.45 4.45 0 0 0 0-6.297 4.456 4.456 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M984.5 571.5a6.364 6.364 0 1 0-9.001-9 6.364 6.364 0 0 0 9.001 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M983.146 570.03a4.452 4.452 0 1 0-6.296-6.297 4.452 4.452 0 0 0 6.296 6.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1156.5 402.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1155.15 401.03a4.45 4.45 0 0 0 0-6.297 4.458 4.458 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1221.5 295.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M1220.15 294.03a4.45 4.45 0 0 0 0-6.297 4.458 4.458 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M887 658a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M886.098 657.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M812 589a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M811.098 588.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M919 523a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M918.098 522.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M933 447a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M932.098 446.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M1029 407a4.237 4.237 0 0 0 0-6 4.242 4.242 0 0 0-6 0 4.237 4.237 0 0 0 0 6 4.242 4.242 0 0 0 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M1028.1 406.02a2.967 2.967 0 0 0 0-4.198 2.971 2.971 0 0 0-4.2 0 2.967 2.967 0 0 0 0 4.198 2.971 2.971 0 0 0 4.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M1283.5 585.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M1282.15 584.03a4.45 4.45 0 0 0 0-6.297 4.456 4.456 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M1329.5 537.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M1328.15 536.03a4.45 4.45 0 0 0 0-6.297 4.456 4.456 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M1255.5 445.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M1254.15 444.03a4.45 4.45 0 0 0 0-6.297 4.456 4.456 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M793 52a7.072 7.072 0 1 0-10.002-10A7.072 7.072 0 0 0 793 52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M791.497 50.367a4.947 4.947 0 1 0-6.996-6.997 4.947 4.947 0 0 0 6.996 6.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M1022 117a7.072 7.072 0 1 0-10-9.998 7.072 7.072 0 0 0 10 9.998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M1020.5 115.367a4.952 4.952 0 0 0 0-6.997 4.952 4.952 0 0 0-7 0 4.952 4.952 0 0 0 0 6.997 4.952 4.952 0 0 0 7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M948 229a7.072 7.072 0 1 0-10.002-10A7.072 7.072 0 0 0 948 229Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M946.497 227.367a4.948 4.948 0 1 0-6.998-6.997 4.948 4.948 0 0 0 6.998 6.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M845 252a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M844.098 251.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M851 315a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M850.098 314.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M806 330a4.242 4.242 0 1 0-6-6 4.242 4.242 0 0 0 6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M805.098 329.02a2.969 2.969 0 1 0-4.2-4.198 2.969 2.969 0 0 0 4.2 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M1603.98 185.96c6.44-6.436 6.44-16.871 0-23.307s-16.88-6.436-23.32 0c-6.44 6.436-6.44 16.871 0 23.307 6.44 6.435 16.88 6.435 23.32 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M1600.47 182.153c4.51-4.503 4.51-11.803 0-16.306-4.5-4.503-11.81-4.503-16.31 0-4.51 4.503-4.51 11.803 0 16.306 4.5 4.503 11.81 4.503 16.31 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M1573.75 239.75c5.11-5.109 5.11-13.391 0-18.5s-13.39-5.109-18.5 0c-5.11 5.109-5.11 13.391 0 18.5s13.39 5.109 18.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M1570.97 236.729c3.57-3.575 3.57-9.37 0-12.944a9.16 9.16 0 0 0-12.95 0c-3.57 3.574-3.57 9.369 0 12.944a9.16 9.16 0 0 0 12.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M1530.25 131.25a6.724 6.724 0 0 0 0-9.5 6.718 6.718 0 0 0-9.5 0 6.724 6.724 0 0 0 0 9.5 6.718 6.718 0 0 0 9.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M1528.82 129.698a4.69 4.69 0 0 0 0-6.646 4.703 4.703 0 0 0-6.65 0 4.709 4.709 0 0 0 0 6.646 4.703 4.703 0 0 0 6.65 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M1528.75 241.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M1527.47 240.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M1519.75 295.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M1518.47 294.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M1645.75 272.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M1644.47 271.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M1659.75 234.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M1658.47 233.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M1707.75 302.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M1706.47 301.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M1681.75 349.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M1680.47 348.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M1721.75 449.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M1720.47 448.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M1721.75 449.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M1720.47 448.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M1649.75 409.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M1648.47 408.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M1649.75 409.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M1648.47 408.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M1637.75 400.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M1636.47 399.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M1544.75 443.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M1543.47 442.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M1415.75 440.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M1414.47 439.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M1441.75 546.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M1440.47 545.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M1586.75 463.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M1585.47 462.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M1648.75 479.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M1647.47 478.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M1610.75 493.75a4.605 4.605 0 0 0 0-6.5 4.596 4.596 0 0 0-6.5 0 4.605 4.605 0 0 0 0 6.5 4.596 4.596 0 0 0 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M1609.77 492.688a3.207 3.207 0 0 0 0-4.547 3.218 3.218 0 0 0-4.55 0 3.216 3.216 0 0 0 .01 4.547 3.206 3.206 0 0 0 4.54 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M1629.75 512.75a4.605 4.605 0 0 0 0-6.5 4.596 4.596 0 0 0-6.5 0 4.605 4.605 0 0 0 0 6.5 4.596 4.596 0 0 0 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M1628.77 511.688a3.207 3.207 0 0 0 0-4.547 3.218 3.218 0 0 0-4.55 0 3.216 3.216 0 0 0 .01 4.547 3.206 3.206 0 0 0 4.54 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M1568.25 526.25a3.889 3.889 0 1 0-5.5-5.501 3.889 3.889 0 0 0 5.5 5.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M1567.42 525.352a2.708 2.708 0 0 0 0-3.848 2.723 2.723 0 0 0-3.85 0 2.726 2.726 0 0 0 0 3.848 2.724 2.724 0 0 0 3.85 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M1603.75 550.75a4.605 4.605 0 0 0 0-6.5 4.596 4.596 0 0 0-6.5 0 4.605 4.605 0 0 0 0 6.5 4.596 4.596 0 0 0 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M1602.77 549.688a3.207 3.207 0 0 0 0-4.547 3.218 3.218 0 0 0-4.55 0 3.216 3.216 0 0 0 .01 4.547 3.206 3.206 0 0 0 4.54 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M1629.75 548.75a4.605 4.605 0 0 0 0-6.5 4.596 4.596 0 0 0-6.5 0 4.605 4.605 0 0 0 0 6.5 4.596 4.596 0 0 0 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M1628.77 547.688a3.207 3.207 0 0 0 0-4.547 3.218 3.218 0 0 0-4.55 0 3.216 3.216 0 0 0 .01 4.547 3.206 3.206 0 0 0 4.54 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M1535.75 475.75a4.605 4.605 0 0 0 0-6.5 4.596 4.596 0 0 0-6.5 0 4.605 4.605 0 0 0 0 6.5 4.596 4.596 0 0 0 6.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M1534.77 474.688a3.207 3.207 0 0 0 0-4.547 3.218 3.218 0 0 0-4.55 0 3.216 3.216 0 0 0 .01 4.547 3.206 3.206 0 0 0 4.54 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M1693 594a4.237 4.237 0 0 0 0-6 4.242 4.242 0 0 0-6 0 4.237 4.237 0 0 0 0 6 4.242 4.242 0 0 0 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M1692.1 593.02a2.967 2.967 0 0 0 0-4.198 2.971 2.971 0 0 0-4.2 0 2.967 2.967 0 0 0 0 4.198 2.971 2.971 0 0 0 4.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M1644 612a4.237 4.237 0 0 0 0-6 4.242 4.242 0 0 0-6 0 4.237 4.237 0 0 0 0 6 4.242 4.242 0 0 0 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M1643.1 611.02a2.967 2.967 0 0 0 0-4.198 2.971 2.971 0 0 0-4.2 0 2.967 2.967 0 0 0 0 4.198 2.971 2.971 0 0 0 4.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M1730 650a4.237 4.237 0 0 0 0-6 4.242 4.242 0 0 0-6 0 4.237 4.237 0 0 0 0 6 4.242 4.242 0 0 0 6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M1729.1 649.02a2.967 2.967 0 0 0 0-4.198 2.971 2.971 0 0 0-4.2 0 2.967 2.967 0 0 0 0 4.198 2.971 2.971 0 0 0 4.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M1669.75 530.75a7.426 7.426 0 1 0-10.5 0 7.426 7.426 0 0 0 10.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M1668.17 529.035a5.192 5.192 0 0 0 0-7.346c-2.03-2.029-5.32-2.029-7.34 0a5.192 5.192 0 0 0 0 7.346c2.02 2.029 5.31 2.029 7.34 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M1339.5 631.5a6.355 6.355 0 0 0 0-9 6.364 6.364 0 0 0-9 0 6.355 6.355 0 0 0 0 9 6.364 6.364 0 0 0 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M1338.15 630.03a4.45 4.45 0 0 0 0-6.297 4.456 4.456 0 0 0-6.3 0 4.45 4.45 0 0 0 0 6.297 4.456 4.456 0 0 0 6.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M1287.25 672.25a5.303 5.303 0 1 0-7.5-7.5 5.303 5.303 0 0 0 7.5 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M1286.12 671.025a3.708 3.708 0 0 0 0-5.247 3.702 3.702 0 0 0-5.24 0 3.708 3.708 0 0 0 0 5.247 3.702 3.702 0 0 0 5.24 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M1171.25 660.25a5.303 5.303 0 1 0-7.5-7.5 5.303 5.303 0 0 0 7.5 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M1170.12 659.025a3.708 3.708 0 0 0 0-5.247 3.702 3.702 0 0 0-5.24 0 3.708 3.708 0 0 0 0 5.247 3.702 3.702 0 0 0 5.24 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M1238.5 576.5a3.535 3.535 0 1 0-5-5.001 3.535 3.535 0 0 0 5 5.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M1237.75 575.683c.96-.966.96-2.532 0-3.498a2.476 2.476 0 0 0-3.5 0 2.466 2.466 0 0 0 0 3.498c.97.966 2.53.966 3.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M1264.5 556.5a3.535 3.535 0 1 0-5-5.001 3.535 3.535 0 0 0 5 5.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "M1263.75 555.683c.96-.966.96-2.532 0-3.498a2.476 2.476 0 0 0-3.5 0 2.466 2.466 0 0 0 0 3.498c.97.966 2.53.966 3.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M1297.5 560.5a3.535 3.535 0 1 0-5-5.001 3.535 3.535 0 0 0 5 5.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M1296.75 559.683c.96-.966.96-2.532 0-3.498a2.476 2.476 0 0 0-3.5 0 2.466 2.466 0 0 0 0 3.498c.97.966 2.53.966 3.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M1242.5 499.5a3.535 3.535 0 1 0-5-5.001 3.535 3.535 0 0 0 5 5.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M1241.75 498.683c.96-.966.96-2.532 0-3.498a2.476 2.476 0 0 0-3.5 0 2.466 2.466 0 0 0 0 3.498c.97.966 2.53.966 3.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M1589.75 407.75a7.426 7.426 0 1 0-10.5 0 7.426 7.426 0 0 0 10.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M1588.17 406.035a5.192 5.192 0 0 0 0-7.346c-2.03-2.029-5.32-2.029-7.34 0a5.192 5.192 0 0 0 0 7.346c2.02 2.029 5.31 2.029 7.34 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M1673.25 545.25a3.889 3.889 0 1 0-5.5-5.501 3.889 3.889 0 0 0 5.5 5.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "M1672.42 544.352a2.708 2.708 0 0 0 0-3.848 2.723 2.723 0 0 0-3.85 0 2.726 2.726 0 0 0 0 3.848 2.724 2.724 0 0 0 3.85 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M1643.25 579.25a3.889 3.889 0 1 0-5.5-5.501 3.889 3.889 0 0 0 5.5 5.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "M1642.42 578.352a2.708 2.708 0 0 0 0-3.848 2.723 2.723 0 0 0-3.85 0 2.726 2.726 0 0 0 0 3.848 2.724 2.724 0 0 0 3.85 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M1598.75 379.75a6.005 6.005 0 0 0 0-8.5 6.01 6.01 0 0 0-8.5 0 6.005 6.005 0 0 0 0 8.5 6.01 6.01 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M1597.47 378.362a4.21 4.21 0 0 0 0-5.947 4.21 4.21 0 0 0-5.95 0 4.21 4.21 0 0 0 0 5.947 4.21 4.21 0 0 0 5.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M1490.25 110.25a6.717 6.717 0 1 0-9.5-9.5 6.717 6.717 0 0 0 9.5 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "M1488.82 108.698a4.69 4.69 0 0 0 0-6.646 4.703 4.703 0 0 0-6.65 0 4.709 4.709 0 0 0 0 6.646 4.703 4.703 0 0 0 6.65 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "M438.981 1453.96c6.439-6.44 6.439-16.87 0-23.31-6.44-6.43-16.881-6.43-23.321 0-6.44 6.44-6.44 16.87 0 23.31 6.44 6.44 16.881 6.44 23.321 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "M435.474 1450.15c4.505-4.5 4.505-11.8 0-16.3-4.506-4.51-11.811-4.51-16.316 0-4.506 4.5-4.506 11.8 0 16.3 4.505 4.51 11.81 4.51 16.316 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "M400.981 1663.96c6.439-6.44 6.439-16.87 0-23.31-6.44-6.43-16.881-6.43-23.321 0-6.44 6.44-6.44 16.87 0 23.31 6.44 6.44 16.881 6.44 23.321 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "M397.474 1660.15c4.505-4.5 4.505-11.8 0-16.3-4.506-4.51-11.811-4.51-16.316 0-4.506 4.5-4.506 11.8 0 16.3 4.505 4.51 11.81 4.51 16.316 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "M370.75 1717.75c5.109-5.11 5.109-13.39 0-18.5-5.109-5.11-13.391-5.11-18.5 0s-5.109 13.39 0 18.5c5.109 5.11 13.391 5.11 18.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "M367.968 1714.73c3.574-3.58 3.574-9.37 0-12.94a9.143 9.143 0 0 0-12.944 0c-3.574 3.57-3.574 9.36 0 12.94 3.575 3.57 9.37 3.57 12.944 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M327.25 1609.25a6.718 6.718 0 0 0 0-9.5 6.724 6.724 0 0 0-9.5 0 6.718 6.718 0 0 0 0 9.5 6.724 6.724 0 0 0 9.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bA)",
    d: "M325.821 1607.7a4.703 4.703 0 0 0 0-6.65 4.709 4.709 0 0 0-6.646 0 4.703 4.703 0 0 0 0 6.65 4.709 4.709 0 0 0 6.646 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "M325.75 1719.75a6.01 6.01 0 0 0 0-8.5 6.005 6.005 0 0 0-8.5 0 6.01 6.01 0 0 0 0 8.5 6.005 6.005 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "M324.471 1718.36a4.21 4.21 0 0 0 0-5.95 4.21 4.21 0 0 0-5.947 0 4.21 4.21 0 0 0 0 5.95 4.21 4.21 0 0 0 5.947 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M456.75 1712.75a6.01 6.01 0 0 0 0-8.5 6.005 6.005 0 0 0-8.5 0 6.01 6.01 0 0 0 0 8.5 6.005 6.005 0 0 0 8.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "M455.471 1711.36a4.21 4.21 0 0 0 0-5.95 4.21 4.21 0 0 0-5.947 0 4.21 4.21 0 0 0 0 5.95 4.21 4.21 0 0 0 5.947 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M287.25 1588.25a6.718 6.718 0 0 0 0-9.5 6.724 6.724 0 0 0-9.5 0 6.718 6.718 0 0 0 0 9.5 6.724 6.724 0 0 0 9.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "M285.821 1586.7a4.703 4.703 0 0 0 0-6.65 4.709 4.709 0 0 0-6.646 0 4.703 4.703 0 0 0 0 6.65 4.709 4.709 0 0 0 6.646 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "M557 1496c4.418-4.42 4.418-11.58 0-16s-11.582-4.42-16 0c-4.418 4.42-4.418 11.58 0 16s11.582 4.42 16 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "M554.594 1493.39a7.917 7.917 0 1 0-11.194-11.2 7.917 7.917 0 0 0 11.194 11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M621 1460c3.314-3.31 3.314-8.69 0-12a8.492 8.492 0 0 0-12 0c-3.314 3.31-3.314 8.69 0 12a8.492 8.492 0 0 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "M619.195 1458.04a5.943 5.943 0 0 0 0-8.4 5.952 5.952 0 0 0-8.396 0 5.943 5.943 0 0 0 0 8.4 5.934 5.934 0 0 0 8.396 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "M1103.25 1099.25c-5.94 5.94-15.56 5.94-21.5 0-5.94-5.94-5.94-15.56 0-21.5 5.94-5.94 15.56-5.94 21.5 0 5.94 5.94 5.94 15.56 0 21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M1099.74 1096.02c-4.16 4.15-10.89 4.15-15.04 0a10.635 10.635 0 0 1 0-15.05c4.15-4.15 10.88-4.15 15.04 0 4.15 4.16 4.15 10.89 0 15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M1672.5 1299.5c-5.25 5.25-13.75 5.25-19 0s-5.25-13.75 0-19 13.75-5.25 19 0 5.25 13.75 0 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "M1669.4 1296.64c-3.67 3.67-9.63 3.67-13.3 0a9.397 9.397 0 0 1 0-13.29c3.67-3.67 9.63-3.67 13.3 0a9.397 9.397 0 0 1 0 13.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M1680.5 1231.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "M1679.03 1230.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M1631.5 1052.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M1630.03 1051.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M1462.5 1224.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "M1461.03 1223.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M1355.5 1289.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M1354.03 1288.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M1718 955a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M1717.02 954.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M1649 880a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "M1648.02 879.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M1583 987a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M1582.02 986.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M1507 1001a4.237 4.237 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M1506.02 1000.1a2.97 2.97 0 1 1-4.2-4.199 2.97 2.97 0 0 1 4.2 4.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M1467 1097a4.237 4.237 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.237 4.237 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "M1466.02 1096.1a2.97 2.97 0 1 1-4.2-4.199 2.97 2.97 0 0 1 4.2 4.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "M1645.5 1351.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ci)",
    d: "M1644.03 1350.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "M1597.5 1397.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ck)",
    d: "M1596.03 1396.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "M1505.5 1323.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cm)",
    d: "M1504.03 1322.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M1015.5 1069.5a7.774 7.774 0 0 1-11 0 7.774 7.774 0 0 1 0-11 7.774 7.774 0 0 1 11 0 7.774 7.774 0 0 1 0 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#co)",
    d: "M1013.7 1067.85a5.444 5.444 0 0 1-7.69 0 5.438 5.438 0 0 1 0-7.7 5.426 5.426 0 0 1 7.69 0 5.438 5.438 0 0 1 0 7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "M1036 926a7.072 7.072 0 1 1-10-10.002A7.072 7.072 0 0 1 1036 926Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cq)",
    d: "M1034.37 924.496a4.952 4.952 0 0 1-7 0 4.95 4.95 0 0 1 0-6.996 4.952 4.952 0 0 1 7 0 4.95 4.95 0 0 1 0 6.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M1112 861a7.072 7.072 0 1 1-10-10.002A7.072 7.072 0 0 1 1112 861Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cs)",
    d: "M1110.37 859.496a4.952 4.952 0 0 1-7 0 4.95 4.95 0 0 1 0-6.996 4.952 4.952 0 0 1 7 0 4.95 4.95 0 0 1 0 6.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "M1177 1090a7.074 7.074 0 0 1-10 0 7.074 7.074 0 0 1 0-10 7.074 7.074 0 0 1 10 0 7.074 7.074 0 0 1 0 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cu)",
    d: "M1175.37 1088.5a4.955 4.955 0 0 1-7 0 4.955 4.955 0 0 1 0-7 4.955 4.955 0 0 1 7 0 4.955 4.955 0 0 1 0 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cv)",
    d: "M1289 1016a7.074 7.074 0 0 1-10 0 7.074 7.074 0 0 1 0-10 7.074 7.074 0 0 1 10 0 7.074 7.074 0 0 1 0 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "M1287.37 1014.5a4.955 4.955 0 0 1-7 0 4.955 4.955 0 0 1 0-7 4.955 4.955 0 0 1 7 0 4.955 4.955 0 0 1 0 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "M1312 913a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cy)",
    d: "M1311.02 912.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cz)",
    d: "M1375 919a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cA)",
    d: "M1374.02 918.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cB)",
    d: "M1390 874a4.242 4.242 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.242 4.242 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cC)",
    d: "M1389.02 873.098a2.971 2.971 0 0 1-4.2 0 2.967 2.967 0 0 1 0-4.198 2.971 2.971 0 0 1 4.2 0 2.967 2.967 0 0 1 0 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cD)",
    d: "M1035.96 1709.98c-6.44 6.44-16.87 6.44-23.31 0-6.43-6.44-6.43-16.88 0-23.32 6.44-6.44 16.87-6.44 23.31 0 6.44 6.44 6.44 16.88 0 23.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cE)",
    d: "M1032.15 1706.47c-4.5 4.51-11.8 4.51-16.3 0-4.51-4.5-4.51-11.81 0-16.31 4.5-4.51 11.8-4.51 16.3 0 4.51 4.5 4.51 11.81 0 16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cF)",
    d: "M1245.96 1671.98c-6.44 6.44-16.87 6.44-23.31 0-6.43-6.44-6.43-16.88 0-23.32 6.44-6.44 16.87-6.44 23.31 0 6.44 6.44 6.44 16.88 0 23.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cG)",
    d: "M1242.15 1668.47c-4.5 4.51-11.8 4.51-16.3 0-4.51-4.5-4.51-11.81 0-16.31 4.5-4.51 11.8-4.51 16.3 0 4.51 4.5 4.51 11.81 0 16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "M1299.75 1641.75c-5.11 5.11-13.39 5.11-18.5 0-5.11-5.11-5.11-13.39 0-18.5 5.11-5.11 13.39-5.11 18.5 0 5.11 5.11 5.11 13.39 0 18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cI)",
    d: "M1296.73 1638.97c-3.57 3.57-9.37 3.57-12.94 0a9.15 9.15 0 0 1 0-12.95c3.57-3.57 9.37-3.57 12.94 0a9.168 9.168 0 0 1 0 12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cJ)",
    d: "M1191.25 1598.25a6.724 6.724 0 0 1-9.5 0 6.724 6.724 0 0 1 0-9.5 6.724 6.724 0 0 1 9.5 0 6.724 6.724 0 0 1 0 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cK)",
    d: "M1189.7 1596.82a4.696 4.696 0 0 1-6.65 0c-1.83-1.83-1.83-4.81 0-6.65a4.714 4.714 0 0 1 6.65 0c1.83 1.84 1.83 4.82 0 6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M1301.75 1596.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cM)",
    d: "M1300.36 1595.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M1355.75 1587.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cO)",
    d: "M1354.36 1586.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cP)",
    d: "M1332.75 1713.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cQ)",
    d: "M1331.36 1712.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M1294.75 1727.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cS)",
    d: "M1293.36 1726.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cT)",
    d: "M1469.75 1717.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cU)",
    d: "M1468.36 1716.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cV)",
    d: "M1469.75 1717.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cW)",
    d: "M1468.36 1716.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cX)",
    d: "M1460.75 1705.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cY)",
    d: "M1459.36 1704.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cZ)",
    d: "M1503.75 1612.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#da)",
    d: "M1502.36 1611.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#db)",
    d: "M1500.75 1483.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dc)",
    d: "M1499.36 1482.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M1606.75 1509.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#de)",
    d: "M1605.36 1508.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#df)",
    d: "M1523.75 1654.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dg)",
    d: "M1522.36 1653.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dh)",
    d: "M1539.75 1716.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#di)",
    d: "M1538.36 1715.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj)",
    d: "M1553.75 1678.75a4.605 4.605 0 0 1-6.5 0 4.605 4.605 0 0 1 0-6.5 4.605 4.605 0 0 1 6.5 0 4.605 4.605 0 0 1 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dk)",
    d: "M1552.69 1677.77a3.21 3.21 0 0 1-4.55 0 3.21 3.21 0 0 1 0-4.55 3.217 3.217 0 0 1 4.55 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dl)",
    d: "M1572.75 1697.75a4.605 4.605 0 0 1-6.5 0 4.605 4.605 0 0 1 0-6.5 4.605 4.605 0 0 1 6.5 0 4.605 4.605 0 0 1 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dm)",
    d: "M1571.69 1696.77a3.21 3.21 0 0 1-4.55 0 3.21 3.21 0 0 1 0-4.55 3.217 3.217 0 0 1 4.55 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "M1586.25 1636.25a3.887 3.887 0 0 1-5.5 0 3.887 3.887 0 0 1 0-5.5 3.887 3.887 0 0 1 5.5 0 3.887 3.887 0 0 1 0 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#do)",
    d: "M1585.35 1635.42a2.71 2.71 0 0 1-3.85 0 2.728 2.728 0 0 1 0-3.85 2.728 2.728 0 0 1 3.85 0 2.728 2.728 0 0 1 0 3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dp)",
    d: "M1610.75 1671.75a4.605 4.605 0 0 1-6.5 0 4.605 4.605 0 0 1 0-6.5 4.605 4.605 0 0 1 6.5 0 4.605 4.605 0 0 1 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dq)",
    d: "M1609.69 1670.77a3.21 3.21 0 0 1-4.55 0 3.21 3.21 0 0 1 0-4.55 3.217 3.217 0 0 1 4.55 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dr)",
    d: "M1608.75 1697.75a4.605 4.605 0 0 1-6.5 0 4.605 4.605 0 0 1 0-6.5 4.605 4.605 0 0 1 6.5 0 4.605 4.605 0 0 1 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ds)",
    d: "M1607.69 1696.77a3.21 3.21 0 0 1-4.55 0 3.21 3.21 0 0 1 0-4.55 3.217 3.217 0 0 1 4.55 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M1535.75 1603.75a4.605 4.605 0 0 1-6.5 0 4.605 4.605 0 0 1 0-6.5 4.605 4.605 0 0 1 6.5 0 4.605 4.605 0 0 1 0 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#du)",
    d: "M1534.69 1602.77a3.21 3.21 0 0 1-4.55 0 3.21 3.21 0 0 1 0-4.55 3.217 3.217 0 0 1 4.55 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dv)",
    d: "M1672 1712a4.237 4.237 0 0 1-6 0 4.237 4.237 0 0 1 0-6 4.237 4.237 0 0 1 6 0 4.237 4.237 0 0 1 0 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dw)",
    d: "M1671.02 1711.1a2.97 2.97 0 1 1-4.2-4.199 2.97 2.97 0 0 1 4.2 4.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx)",
    d: "M1590.75 1737.75c-2.9 2.9-7.6 2.9-10.5 0-2.9-2.9-2.9-7.6 0-10.5 2.9-2.9 7.6-2.9 10.5 0 2.9 2.9 2.9 7.6 0 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dy)",
    d: "M1589.03 1736.17a5.185 5.185 0 0 1-7.34 0 5.197 5.197 0 0 1 0-7.35c2.03-2.02 5.32-2.02 7.34 0a5.197 5.197 0 0 1 0 7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dz)",
    d: "M1691.5 1407.5a6.355 6.355 0 0 1-9 0 6.355 6.355 0 0 1 0-9 6.355 6.355 0 0 1 9 0 6.355 6.355 0 0 1 0 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dA)",
    d: "M1690.03 1406.15a4.454 4.454 0 1 1-6.3-6.3 4.454 4.454 0 1 1 6.3 6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dB)",
    d: "M1732.25 1355.25a5.305 5.305 0 0 1-7.5 0 5.305 5.305 0 0 1 0-7.5 5.305 5.305 0 0 1 7.5 0 5.305 5.305 0 0 1 0 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dC)",
    d: "M1731.03 1354.12a3.712 3.712 0 1 1-5.25-5.25 3.73 3.73 0 0 1 5.25 0 3.72 3.72 0 0 1 0 5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dD)",
    d: "M1720.25 1239.25a5.305 5.305 0 0 1-7.5 0 5.305 5.305 0 0 1 0-7.5 5.305 5.305 0 0 1 7.5 0 5.305 5.305 0 0 1 0 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dE)",
    d: "M1719.03 1238.12a3.712 3.712 0 1 1-5.25-5.25 3.73 3.73 0 0 1 5.25 0 3.72 3.72 0 0 1 0 5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "M1636.5 1306.5a3.537 3.537 0 0 1-5 0 3.537 3.537 0 0 1 0-5 3.537 3.537 0 0 1 5 0 3.537 3.537 0 0 1 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dG)",
    d: "M1635.68 1305.75c-.96.96-2.53.96-3.5 0-.96-.97-.96-2.53 0-3.5.97-.97 2.54-.97 3.5 0 .97.97.97 2.53 0 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dH)",
    d: "M1616.5 1332.5a3.537 3.537 0 0 1-5 0 3.537 3.537 0 0 1 0-5 3.537 3.537 0 0 1 5 0 3.537 3.537 0 0 1 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dI)",
    d: "M1615.68 1331.75c-.96.96-2.53.96-3.5 0-.96-.97-.96-2.53 0-3.5.97-.97 2.54-.97 3.5 0 .97.97.97 2.53 0 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dJ)",
    d: "M1620.5 1365.5a3.537 3.537 0 0 1-5 0 3.537 3.537 0 0 1 0-5 3.537 3.537 0 0 1 5 0 3.537 3.537 0 0 1 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dK)",
    d: "M1619.68 1364.75c-.96.96-2.53.96-3.5 0-.96-.97-.96-2.53 0-3.5.97-.97 2.54-.97 3.5 0 .97.97.97 2.53 0 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL)",
    d: "M1559.5 1310.5a3.537 3.537 0 0 1-5 0 3.537 3.537 0 0 1 0-5 3.537 3.537 0 0 1 5 0 3.537 3.537 0 0 1 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dM)",
    d: "M1558.68 1309.75c-.96.96-2.53.96-3.5 0-.96-.97-.96-2.53 0-3.5.97-.97 2.54-.97 3.5 0 .97.97.97 2.53 0 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dN)",
    d: "M1467.75 1657.75c-2.9 2.9-7.6 2.9-10.5 0-2.9-2.9-2.9-7.6 0-10.5 2.9-2.9 7.6-2.9 10.5 0 2.9 2.9 2.9 7.6 0 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dO)",
    d: "M1466.03 1656.17a5.185 5.185 0 0 1-7.34 0 5.197 5.197 0 0 1 0-7.35c2.03-2.02 5.32-2.02 7.34 0a5.197 5.197 0 0 1 0 7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dP)",
    d: "M1639.25 1711.25a3.887 3.887 0 0 1-5.5 0 3.887 3.887 0 0 1 0-5.5 3.887 3.887 0 0 1 5.5 0 3.887 3.887 0 0 1 0 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dQ)",
    d: "M1638.35 1710.42a2.71 2.71 0 0 1-3.85 0 2.728 2.728 0 0 1 0-3.85 2.728 2.728 0 0 1 3.85 0 2.728 2.728 0 0 1 0 3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dR)",
    d: "M1439.75 1666.75a6.005 6.005 0 0 1-8.5 0 6.005 6.005 0 0 1 0-8.5 6.005 6.005 0 0 1 8.5 0 6.005 6.005 0 0 1 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dS)",
    d: "M1438.36 1665.47a4.2 4.2 0 0 1-5.94 0 4.195 4.195 0 0 1 0-5.95 4.2 4.2 0 0 1 5.94 0 4.213 4.213 0 0 1 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dT)",
    d: "M1170.25 1558.25a6.724 6.724 0 0 1-9.5 0 6.724 6.724 0 0 1 0-9.5 6.724 6.724 0 0 1 9.5 0 6.724 6.724 0 0 1 0 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dU)",
    d: "M1168.7 1556.82a4.696 4.696 0 0 1-6.65 0c-1.83-1.83-1.83-4.81 0-6.65a4.714 4.714 0 0 1 6.65 0c1.83 1.84 1.83 4.82 0 6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dV)",
    d: "M541.75 256.25c5.937 5.937 15.563 5.937 21.5 0 5.937-5.937 5.937-15.563 0-21.5-5.937-5.937-15.563-5.937-21.5 0-5.937 5.937-5.937 15.563 0 21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dW)",
    d: "M545.262 253.017c4.154 4.154 10.889 4.154 15.042 0 4.154-4.154 4.154-10.888 0-15.042s-10.888-4.154-15.042 0-4.154 10.888 0 15.042Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dX)",
    d: "M-27.5 456.5c5.247 5.247 13.753 5.247 19 0s5.247-13.753 0-19-13.753-5.247-19 0-5.247 13.753 0 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dY)",
    d: "M13.5 209.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dZ)",
    d: "M14.97 208.147a4.453 4.453 0 1 0 6.296-6.297 4.453 4.453 0 0 0-6.295 6.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ea)",
    d: "M182.5 381.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eb)",
    d: "M183.971 380.147a4.454 4.454 0 0 0 6.297 0 4.452 4.452 0 1 0-6.297 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ec)",
    d: "M289.5 446.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed)",
    d: "M290.971 445.147a4.454 4.454 0 0 0 6.297 0 4.452 4.452 0 1 0-6.297 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ee)",
    d: "M-4 37a4.243 4.243 0 1 0 6-6 4.243 4.243 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ef)",
    d: "M-3.02 36.098A2.968 2.968 0 1 0 1.176 31.9a2.968 2.968 0 0 0-4.198 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eg)",
    d: "M62 144a4.242 4.242 0 1 0 6-6 4.242 4.242 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eh)",
    d: "M62.98 143.098a2.969 2.969 0 1 0 4.197-4.199 2.969 2.969 0 0 0-4.198 4.199Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ei)",
    d: "M138 158a4.242 4.242 0 1 0 6-6 4.242 4.242 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ej)",
    d: "M138.979 157.098a2.969 2.969 0 1 0 4.198-4.2 2.969 2.969 0 0 0-4.198 4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ek)",
    d: "M178 254a4.242 4.242 0 1 0 6-6 4.242 4.242 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#el)",
    d: "M178.979 253.098a2.969 2.969 0 1 0 4.198-4.2 2.969 2.969 0 0 0-4.198 4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#em)",
    d: "M-.5 508.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#en)",
    d: "M.97 507.147a4.453 4.453 0 1 0 6.296-6.297 4.453 4.453 0 0 0-6.295 6.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eo)",
    d: "M47.5 554.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ep)",
    d: "M48.97 553.147a4.453 4.453 0 1 0 6.296-6.297 4.453 4.453 0 0 0-6.295 6.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eq)",
    d: "M139.5 480.5a6.364 6.364 0 1 0 9-9.001 6.364 6.364 0 0 0-9 9.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#er)",
    d: "M140.971 479.147a4.454 4.454 0 0 0 6.297 0 4.452 4.452 0 1 0-6.297 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#es)",
    d: "M629.5 226.5a7.777 7.777 0 0 0 11 0 7.777 7.777 0 0 0 0-11 7.777 7.777 0 0 0-11 0 7.777 7.777 0 0 0 0 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#et)",
    d: "M631.296 224.846a5.443 5.443 0 0 0 7.697-7.696 5.442 5.442 0 0 0-7.697 7.696Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eu)",
    d: "M609 83a7.071 7.071 0 1 0 10-10 7.071 7.071 0 0 0-10 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ev)",
    d: "M610.633 81.496a4.947 4.947 0 1 0 6.996-6.995 4.947 4.947 0 0 0-6.996 6.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ew)",
    d: "M533 18a7.071 7.071 0 1 0 10-10 7.071 7.071 0 0 0-10 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ex)",
    d: "M534.633 16.496a4.947 4.947 0 1 0 6.996-6.995 4.947 4.947 0 0 0-6.996 6.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ey)",
    d: "M468 247a7.072 7.072 0 1 0 10-10.002A7.072 7.072 0 0 0 468 247Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ez)",
    d: "M469.633 245.496a4.947 4.947 0 1 0 6.996-6.995 4.947 4.947 0 0 0-6.996 6.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eA)",
    d: "M356 173a7.072 7.072 0 1 0 10-10.002A7.072 7.072 0 0 0 356 173Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eB)",
    d: "M357.633 171.496a4.947 4.947 0 1 0 6.996-6.995 4.947 4.947 0 0 0-6.996 6.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eC)",
    d: "M333 70a4.243 4.243 0 1 0 6-6 4.243 4.243 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eD)",
    d: "M333.979 69.098a2.969 2.969 0 1 0 4.198-4.198 2.969 2.969 0 0 0-4.198 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eE)",
    d: "M270 76a4.243 4.243 0 1 0 6-6 4.243 4.243 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eF)",
    d: "M270.979 75.098a2.969 2.969 0 1 0 4.198-4.198 2.969 2.969 0 0 0-4.198 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eG)",
    d: "M255 31a4.243 4.243 0 1 0 6-6 4.243 4.243 0 0 0-6 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eH)",
    d: "M255.979 30.098a2.969 2.969 0 1 0 4.198-4.198 2.969 2.969 0 0 0-4.198 4.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eI)",
    d: "M609.04 866.981c6.436 6.439 16.871 6.439 23.307 0 6.435-6.44 6.435-16.881 0-23.321-6.436-6.44-16.871-6.44-23.307 0s-6.436 16.881 0 23.321Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eJ)",
    d: "M612.847 863.474c4.503 4.505 11.803 4.505 16.306 0 4.503-4.506 4.503-11.811 0-16.316-4.503-4.506-11.803-4.506-16.306 0-4.503 4.505-4.503 11.81 0 16.316Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eK)",
    d: "M399.04 828.981c6.436 6.439 16.871 6.439 23.307 0 6.435-6.44 6.435-16.881 0-23.321-6.436-6.44-16.871-6.44-23.307 0s-6.436 16.881 0 23.321Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eL)",
    d: "M402.847 825.474c4.503 4.505 11.803 4.505 16.306 0 4.503-4.506 4.503-11.811 0-16.316-4.503-4.506-11.803-4.506-16.306 0-4.503 4.505-4.503 11.81 0 16.316Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eM)",
    d: "M345.25 798.75c5.109 5.109 13.391 5.109 18.5 0s5.109-13.391 0-18.5-13.391-5.109-18.5 0-5.109 13.391 0 18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eN)",
    d: "M348.27 795.968a9.153 9.153 0 0 0 12.944-12.943 9.15 9.15 0 0 0-12.943 0 9.151 9.151 0 0 0-.001 12.943Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eO)",
    d: "M453.75 755.25a6.718 6.718 0 1 0 9.5-9.502 6.718 6.718 0 0 0-9.5 9.502Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eP)",
    d: "M455.302 753.821a4.698 4.698 0 0 0 6.646 0 4.698 4.698 0 0 0 0-6.646 4.698 4.698 0 0 0-6.646 0 4.698 4.698 0 0 0 0 6.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eQ)",
    d: "M343.25 753.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M344.638 752.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eS)",
    d: "M289.25 744.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eT)",
    d: "M290.638 743.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eU)",
    d: "M312.25 870.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eV)",
    d: "M313.638 869.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eW)",
    d: "M350.25 884.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eX)",
    d: "M351.638 883.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eY)",
    d: "M282.25 932.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eZ)",
    d: "M283.638 931.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fa)",
    d: "M229.25 1015.75a6.005 6.005 0 0 0 8.5 0 6.01 6.01 0 0 0 0-8.5 6.005 6.005 0 0 0-8.5 0 6.01 6.01 0 0 0 0 8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fb)",
    d: "M230.638 1014.47a4.21 4.21 0 0 0 5.947 0 4.21 4.21 0 0 0 0-5.95 4.21 4.21 0 0 0-5.947 0 4.21 4.21 0 0 0 0 5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fc)",
    d: "M235.25 906.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fd)",
    d: "M236.638 905.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fe)",
    d: "M135.25 946.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ff)",
    d: "M136.638 945.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fg)",
    d: "M135.25 946.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fh)",
    d: "M136.638 945.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fi)",
    d: "M175.25 874.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj)",
    d: "M176.638 873.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fk)",
    d: "M175.25 874.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fl)",
    d: "M176.638 873.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fm)",
    d: "M184.25 862.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fn)",
    d: "M185.638 861.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fo)",
    d: "M141.25 769.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fp)",
    d: "M142.638 768.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fq)",
    d: "M144.25 640.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fr)",
    d: "M145.638 639.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fs)",
    d: "M38.25 666.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ft)",
    d: "M39.638 665.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fu)",
    d: "M121.25 811.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fv)",
    d: "M122.638 810.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fw)",
    d: "M105.25 873.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fx)",
    d: "M106.638 872.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fy)",
    d: "M91.25 835.75a4.596 4.596 0 1 0 6.5-6.5 4.596 4.596 0 0 0-6.5 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fz)",
    d: "M92.312 834.773a3.216 3.216 0 1 0 4.547-4.548 3.216 3.216 0 0 0-4.547 4.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fA)",
    d: "M72.25 854.75a4.596 4.596 0 1 0 6.5-6.5 4.596 4.596 0 0 0-6.5 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fB)",
    d: "M73.312 853.773a3.216 3.216 0 1 0 4.547-4.548 3.216 3.216 0 0 0-4.547 4.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fC)",
    d: "M58.75 793.25a3.889 3.889 0 1 0 5.5-5.499 3.889 3.889 0 0 0-5.5 5.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fD)",
    d: "M59.648 792.423a2.72 2.72 0 1 0 3.848-3.846 2.72 2.72 0 0 0-3.848 3.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fE)",
    d: "M34.25 828.75a4.596 4.596 0 1 0 6.5-6.5 4.596 4.596 0 0 0-6.5 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fF)",
    d: "M35.312 827.773a3.216 3.216 0 1 0 4.547-4.548 3.216 3.216 0 0 0-4.547 4.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fG)",
    d: "M36.25 854.75a4.596 4.596 0 1 0 6.5-6.5 4.596 4.596 0 0 0-6.5 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fH)",
    d: "M37.312 853.773a3.216 3.216 0 1 0 4.547-4.548 3.216 3.216 0 0 0-4.547 4.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fI)",
    d: "M109.25 760.75a4.596 4.596 0 1 0 6.5-6.5 4.596 4.596 0 0 0-6.5 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fJ)",
    d: "M110.312 759.773a3.216 3.216 0 1 0 4.549-4.548 3.216 3.216 0 0 0-4.549 4.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fK)",
    d: "M54.25 894.75a7.426 7.426 0 0 0 10.5-10.5 7.426 7.426 0 0 0-10.5 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fL)",
    d: "M55.965 893.171a5.194 5.194 0 1 0 7.347-7.346 5.194 5.194 0 1 0-7.346 7.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fM)",
    d: "M8.5 463.5a3.535 3.535 0 1 0 5-4.999 3.535 3.535 0 0 0-5 4.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fN)",
    d: "M9.317 462.748a2.474 2.474 0 1 0 3.498-3.498 2.474 2.474 0 0 0-3.498 3.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fO)",
    d: "M28.5 489.5a3.535 3.535 0 1 0 5-4.999 3.535 3.535 0 0 0-5 4.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fP)",
    d: "M29.317 488.748a2.474 2.474 0 1 0 3.498-3.498 2.474 2.474 0 0 0-3.498 3.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fQ)",
    d: "M24.5 522.5a3.535 3.535 0 1 0 5-4.999 3.535 3.535 0 0 0-5 4.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fR)",
    d: "M25.317 521.748a2.474 2.474 0 1 0 3.498-3.498 2.474 2.474 0 0 0-3.498 3.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fS)",
    d: "M85.5 467.5a3.535 3.535 0 1 0 5-4.999 3.535 3.535 0 0 0-5 4.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fT)",
    d: "M86.317 466.748a2.474 2.474 0 1 0 3.499-3.498 2.474 2.474 0 0 0-3.499 3.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fU)",
    d: "M177.25 814.75a7.426 7.426 0 0 0 10.5-10.5 7.426 7.426 0 0 0-10.5 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fV)",
    d: "M178.966 813.171a5.194 5.194 0 1 0 7.346-7.346 5.194 5.194 0 0 0-7.346 0 5.194 5.194 0 0 0 0 7.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fW)",
    d: "M39.75 898.25a3.889 3.889 0 1 0 5.5-5.499 3.889 3.889 0 0 0-5.5 5.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fX)",
    d: "M40.648 897.423a2.72 2.72 0 1 0 3.848-3.846 2.72 2.72 0 0 0-3.848 3.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fY)",
    d: "M5.75 868.25a3.889 3.889 0 1 0 5.5-5.499 3.889 3.889 0 0 0-5.5 5.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fZ)",
    d: "M6.648 867.423a2.72 2.72 0 1 0 3.848-3.846 2.72 2.72 0 0 0-3.848 3.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ga)",
    d: "M205.25 823.75a6.01 6.01 0 1 0 8.5-8.501 6.01 6.01 0 0 0-8.5 8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gb)",
    d: "M206.638 822.472a4.206 4.206 0 1 0 5.947-5.948 4.206 4.206 0 0 0-5.947 5.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gc)",
    d: "M474.75 715.25a6.718 6.718 0 1 0 9.5-9.502 6.718 6.718 0 0 0-9.5 9.502Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gd)",
    d: "M476.302 713.821a4.698 4.698 0 0 0 6.646 0 4.698 4.698 0 0 0 0-6.646 4.698 4.698 0 0 0-6.646 0 4.698 4.698 0 0 0 0 6.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ge)",
    d: "M567 985c4.418 4.418 11.582 4.418 16 0 4.418-4.418 4.418-11.582 0-16-4.418-4.418-11.582-4.418-16 0-4.418 4.418-4.418 11.582 0 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gf)",
    d: "M569.614 982.594a7.916 7.916 0 1 0 11.194-11.195 7.916 7.916 0 0 0-11.194 11.195Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gg)",
    d: "M603 1049a8.492 8.492 0 0 0 12 0c3.314-3.31 3.314-8.69 0-12a8.492 8.492 0 0 0-12 0c-3.314 3.31-3.314 8.69 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gh)",
    d: "M604.96 1047.2a5.952 5.952 0 0 0 8.396 0 5.943 5.943 0 0 0 0-8.4 5.934 5.934 0 0 0-8.396 0 5.943 5.943 0 0 0 0 8.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.99431 -15.17025 16.0805 1.05397 1018 32.389)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.36533 -7.72994 8.19371 .38725 1017.99 32.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 931.751 -349.727) scale(13.435 14.2411)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.32285 -6.8311 7.24096 .34222 1219.79 602.652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 907.798 -310.189) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42993 .1621 1157.95 615.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 792.141 -239.132) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42993 .1621 978.951 566.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 787.92 -415.452) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42993 .1621 1150.95 397.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 763.299 -503.652) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 760.428 -491.97) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 791.303 -144.061) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 883.301 654.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 716.967 -138.523) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 808.301 585.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 735.234 -228.644) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 915.301 519.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 701.661 -274.118) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 929.301 443.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 728.307 -345.366) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 1025.3 403.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 949.114 -391.75) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 943.442 -379.47) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 946.49 -440.307) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42993 .1621 1323.95 532.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 860.375 -446.803) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42993 .1621 1249.95 440.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.46247 -7.05593 7.47928 .49022 786.837 46.948)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.16992 -3.59532 3.81103 .18012 786.835 46.817)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.46247 -7.05593 7.47928 .49022 1015.84 111.948)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.16992 -3.59532 3.81103 .18012 1015.84 111.817)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.46247 -7.05593 7.47928 .49022 941.837 223.948)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 588.24 -381.791) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 553.562 -324.64) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 841.301 248.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 590.194 -296.343) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 847.301 311.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 575.702 -264.82) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 802.301 326.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.248 887.797 -761.544) scale(16.4801 17.4793)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.39628 -8.37937 8.88744 .4203 1589.6 173.879)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.85557 -13.0535 13.83671 .9069 1562.35 230.404)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.31436 -6.65135 7.0504 .33322 1562.34 230.161)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.43935 -6.70313 7.10532 .4657 1524.4 126.451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.16143 -3.41556 3.62048 .17111 1524.39 126.326)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 888.52 -694.59) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1523.51 237.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1514.51 291.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1514.51 291.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 963.569 -741.55) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1640.51 268.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1654.51 230.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1654.51 230.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1702.51 298.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1702.51 298.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1676.51 345.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1676.51 345.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1716.51 445.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1716.51 445.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1716.51 445.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1716.51 445.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1644.51 405.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1644.51 405.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1644.51 405.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1644.51 405.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1027.9 -673.279) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1632.51 396.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1539.51 439.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1539.51 439.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1410.51 436.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1410.51 436.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1436.51 542.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1436.51 542.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1581.51 459.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1581.51 459.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 1643.51 475.456)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1643.51 475.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3006 -4.58635 4.86154 .31864 1606.74 490.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11045 -2.33696 2.47716 .11708 1606.74 490.381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3006 -4.58635 4.86154 .31864 1625.74 509.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11045 -2.33696 2.47716 .11708 1625.74 509.381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.25436 -3.88076 4.1136 .26962 1564.86 523.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.09346 -1.97742 2.09607 .09906 1564.86 523.399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3006 -4.58635 4.86154 .31864 1599.74 547.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11045 -2.33696 2.47716 .11708 1599.74 547.381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3006 -4.58635 4.86154 .31864 1625.74 545.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11045 -2.33696 2.47716 .11708 1625.74 545.381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3006 -4.58635 4.86154 .31864 1531.74 472.466)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.11045 -2.33696 2.47716 .11708 1531.74 472.381)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1160.136 -606.34) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 1689.3 590.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1145.245 -571.18) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 1640.3 608.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1208.53 -598.091) scale(4.24264 4.4972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.10195 -2.1572 2.28662 .10807 1726.3 646.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1112.146 -625.21) scale(7.42462 7.8701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 1107 -609.22) scale(3.7793 4.00605)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1001.67 -398.645) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.15293 -3.23579 3.42992 .1621 1333.95 626.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.34685 -5.29195 5.60946 .36766 1282.63 668.461)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 991.664 -338.16) scale(2.6995 2.86146)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.34685 -5.29195 5.60946 .36766 1166.63 656.461)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 927.373 -283.353) scale(2.6995 2.86146)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.23123 -3.52796 3.73965 .2451 1235.42 573.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 918.546 -360.64) scale(1.79967 1.90764)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.23123 -3.52796 3.73965 .2451 1261.42 553.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.08496 -1.79766 1.90551 .09006 1261.42 553.908)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.23123 -3.52796 3.73965 .2451 1294.42 557.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 939.66 -399.567) scale(1.79967 1.90764)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.23123 -3.52796 3.73965 .2451 1239.42 496.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.08496 -1.79766 1.90551 .09006 1239.42 496.908)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.4856 -7.40872 7.85325 .51473 1583.28 402.446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.17842 -3.77509 4.00158 .18912 1583.28 402.308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.25436 -3.88076 4.1136 .26962 1669.86 542.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.09346 -1.97742 2.09607 .09906 1669.86 542.399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.25436 -3.88076 4.1136 .26962 1639.86 576.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.09346 -1.97742 2.09607 .09906 1639.86 576.399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 997.19 -662.959) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 1593.51 375.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "br",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.43935 -6.70313 7.10532 .4657 1484.4 105.451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.16143 -3.41556 3.62048 .17111 1484.39 105.326)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.248 982.239 494.412) scale(16.4801 17.4793)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.39628 -8.37937 8.88744 .4203 424.604 1441.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.248 1075.35 619.698) scale(16.4801 17.4793)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.39628 -8.37937 8.88744 .4203 386.604 1651.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.85557 -13.0535 13.83671 .9069 359.348 1708.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.31436 -6.65135 7.0504 .33322 359.345 1708.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1017.224 630.65) scale(6.71751 7.12057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.16143 -3.41556 3.62048 .17111 321.393 1604.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 320.511 1715.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 320.509 1715.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.3931 -5.99754 6.35739 .41669 451.511 1708.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.14443 -3.05602 3.23937 .1531 451.509 1708.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 986.014 641.504) scale(6.71751 7.12057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-87.294 970.66 644.162) scale(3.41937 3.62452)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1067.888 451.873) scale(11.3137 11.9925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.27188 -5.7525 6.09764 .28819 547.136 1487.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.25 1082.98 399.4) scale(8.48528 8.9944)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.2039 -4.31438 4.57324 .21614 613.602 1453.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.17025 .99431 -1.05397 -16.0805 1092.39 1086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.72994 .36535 -.38727 -8.19371 1092.11 1086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 810.371 671.114) scale(13.435 14.2411)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 816.117 663.53) scale(6.83873 7.24904)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 817.908 640.407) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 823.437 632.765) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 796.338 550.105) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 801.051 542.687) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 709.023 633.34) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 714.52 626.691) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 654.459 664.088) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 660.252 657.927) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1714.97 951.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 846.21 495.902) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1645.97 876.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ca",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 812.596 457.587) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1579.97 983.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 778.333 510.308) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1503.97 997.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ce",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 740.168 516.41) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1463.97 1093.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 719.034 563.938) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ch",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 798.444 699.835) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ci",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 804.52 692.352) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 773.691 722.049) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ck",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 779.977 714.785) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 728.902 683.543) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 734.85 676.699) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.76152 .50872 -.53924 -8.22722 1009.94 1062.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "co",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.95486 .18692 -.19814 -4.19213 1009.8 1062.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.05593 .46247 -.49022 -7.47928 1030.95 919.837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 504.547 472.09) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.05593 .46247 -.49022 -7.47928 1106.95 854.837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 543.315 440.488) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.05593 .46247 -.49022 -7.47928 1171.95 1083.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 573.11 555.758) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.05593 .46247 -.49022 -7.47928 1283.95 1009.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 629.984 520.081) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1308.97 909.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 643.707 470.108) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1371.97 915.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 675.136 473.852) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1386.97 870.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 683.167 451.529) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.44478 1.07842 -1.14381 -17.44184 1024.19 1695.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.292 491.901 859.9) scale(8.38874 8.89737)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.44478 1.07842 -1.14381 -17.44184 1234.19 1657.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.292 597.35 843.382) scale(8.38874 8.89737)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 618.514 836.297) scale(13.0815 13.8664)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.65135 .31437 -.33323 -7.0504 1290.16 1630.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 567.16 815.62) scale(6.71751 7.12057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.41556 .16143 -.17112 -3.62048 1186.33 1592.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 622.68 816.992) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1297.34 1591.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 649.827 813.376) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1351.34 1582.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 636.265 876) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1328.34 1708.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 617.035 882.378) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1290.34 1722.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 704.7 880.242) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1465.34 1712.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 704.7 880.242) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1465.34 1712.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 700.396 874.095) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1456.34 1700.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 723.418 828.299) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "da",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1499.34 1607.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "db",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 724.03 763.75) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1496.34 1478.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 776.604 778.485) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "de",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1602.34 1504.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "df",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 732.73 849.626) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1519.34 1649.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 739.715 880.888) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "di",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1535.34 1711.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.58635 .3006 -.31864 -4.86154 1550.47 1674.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 755.412 855.679) scale(2.33957 2.47993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.58635 .3006 -.31864 -4.86154 1569.47 1693.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 764.688 865.403) scale(2.33957 2.47993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.88076 .25436 -.26962 -4.1136 1583.47 1632.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.97742 .09346 -.09907 -2.09607 1583.4 1632.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.58635 .3006 -.31864 -4.86154 1607.47 1667.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 783.995 852.852) scale(2.33957 2.47993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.58635 .3006 -.31864 -4.86154 1605.47 1693.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 782.688 865.828) scale(2.33957 2.47993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.58635 .3006 -.31864 -4.86154 1532.47 1599.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 747.298 817.966) scale(2.33957 2.47993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.23356 .27748 -.29413 -4.48757 1668.97 1708.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 814.271 873.859) scale(2.1596 2.28917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 764.387 891.591) scale(7.42462 7.8701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.77509 .17842 -.18913 -4.00158 1585.31 1731.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 820.527 728.588) scale(6.36396 6.7458)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.23579 .15294 -.16211 -3.42992 1686.83 1401.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 842.122 703.607) scale(5.3033 5.6215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 848.23 695.726) scale(2.6995 2.86146)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 838.021 645.41) scale(5.3033 5.6215)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(177.294 843.6 637.584) scale(2.6995 2.86146)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.52796 .23123 -.2451 -3.73965 1633.97 1303.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.79766 .08496 -.09006 -1.90551 1633.91 1303.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.52796 .23123 -.2451 -3.73965 1613.97 1329.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.79766 .08496 -.09006 -1.90551 1613.91 1329.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.52796 .23123 -.2451 -3.73965 1617.97 1362.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.79766 .08496 -.09006 -1.90551 1617.91 1362.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.52796 .23123 -.2451 -3.73965 1556.97 1307.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.79766 .08496 -.09006 -1.90551 1556.91 1307.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 704.196 849.578) scale(7.42462 7.8701)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.77509 .17842 -.18913 -4.00158 1462.31 1651.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.88076 .25436 -.26962 -4.1136 1636.47 1707.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.97742 .09346 -.09907 -2.09607 1636.4 1707.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 690.534 854.251) scale(6.01041 6.37103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.05602 .14444 -.1531 -3.23937 1435.34 1661.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.25 557.315 795.276) scale(6.71751 7.12057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.41556 .16143 -.17112 -3.62048 1165.33 1552.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.17025 .9943 -1.05397 16.0805 552.611 243)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.72994 .36534 -.38726 8.19371 552.894 242.995)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.40623 .87869 -.93141 14.2106 -17.902 444.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 18.047 203.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(2.706 -4308.61 486.546) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ea",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 187.047 375.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.23579 .15293 -.1621 3.42993 187.166 375.952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ec",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 294.047 440.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ed",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.23579 .15293 -.1621 3.42993 294.166 440.952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ee",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 -.969 33.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ef",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 -.89 33.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 65.031 140.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 65.11 140.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ei",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 141.031 154.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ej",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 141.109 154.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ek",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 181.031 250.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "el",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 181.109 250.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "em",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 4.047 502.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "en",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.23579 .15293 -.1621 3.42993 4.166 502.951)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 52.047 548.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ep",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.23579 .15293 -.1621 3.42993 52.166 548.951)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.35033 .41622 -.4412 6.73136 144.047 474.953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "er",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(2.706 -9982.696 3289.49) scale(3.2394 3.43376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "es",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.76152 .50872 -.53924 8.22722 635.057 219.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "et",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.95486 .18692 -.19813 4.19213 635.201 219.719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 -866.54 9417.118) scale(7.07107 7.49533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ev",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.59532 .16992 -.18012 3.81103 614.183 76.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ew",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 88.234 8223.835) scale(7.07107 7.49533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ex",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(2.706 18.54 11399.327) scale(3.59933 3.81528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ey",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 -3441.888 7345.56) scale(7.07107 7.49533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ez",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.59532 .16992 -.18012 3.81103 473.183 240.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 -2367.652 5597.932) scale(7.07107 7.49533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.59532 .16992 -.18012 3.81103 361.183 166.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 336.031 66.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 336.109 66.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 273.031 72.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 273.109 72.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.23356 .27748 -.29413 4.48757 258.031 27.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.1572 .10195 -.10807 2.28662 258.109 27.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.44477 1.0785 -1.14388 17.44183 620.814 852.608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.37938 .39627 -.4203 8.88744 621.121 852.604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.44477 1.0785 -1.14388 17.44183 410.814 814.608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.37938 .39627 -.4203 8.88744 411.121 814.604)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 -11848.23 5809.582) scale(13.0815 13.8664)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.65135 .31436 -.33322 7.0504 354.838 787.345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.70313 .43935 -.4657 7.10532 458.549 749.395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.41556 .16143 -.17111 3.62048 458.674 749.393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 347.544 748.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 347.655 748.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 293.544 739.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 293.655 739.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 316.544 865.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 316.655 865.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 354.544 879.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 354.655 879.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 286.544 927.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 286.655 927.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 233.544 1010.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 233.655 1010.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 239.544 901.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 239.655 901.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fe",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 139.544 941.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ff",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 139.655 941.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 139.544 941.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 139.655 941.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 179.544 869.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 179.655 869.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 179.544 869.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 179.655 869.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 188.544 857.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 188.655 857.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 145.544 764.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 145.655 764.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 148.544 635.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 148.655 635.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 42.544 661.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ft",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 42.655 661.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 125.544 806.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 125.655 806.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 109.544 868.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 109.655 868.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.58635 .3006 -.31864 4.86154 94.534 831.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.33696 .11045 -.11708 2.47716 94.62 831.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.58635 .3006 -.31864 4.86154 75.534 850.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.33696 .11045 -.11708 2.47716 75.62 850.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.88076 .25436 -.26962 4.1136 61.529 789.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.97742 .09346 -.09907 2.09607 61.6 789.859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.58635 .3006 -.31864 4.86154 37.534 824.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.33696 .11045 -.11708 2.47716 37.62 824.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.58635 .3006 -.31864 4.86154 39.534 850.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.33696 .11045 -.11708 2.47716 39.62 850.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.58635 .3006 -.31864 4.86154 112.534 756.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.33696 .11045 -.11708 2.47716 112.62 756.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.40872 .4856 -.51473 7.85325 59.554 888.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.77509 .17842 -.18913 4.00158 59.693 888.277)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(3.75 -7026.66 398.613) scale(3.53553 3.74767)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.79766 .08496 -.09006 1.90551 11.092 460.417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.52796 .23123 -.2451 3.73965 31.026 486.419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.79766 .08496 -.09006 1.90551 31.092 486.417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.52796 .23123 -.2451 3.73965 27.026 519.419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.79766 .08496 -.09006 1.90551 27.092 519.417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.52796 .23123 -.2451 3.73965 88.026 464.419)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.79766 .08496 -.09006 1.90551 88.092 464.417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.40872 .4856 -.51473 7.85325 182.554 808.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.77509 .17842 -.18913 4.00158 182.693 808.277)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.88076 .25436 -.26962 4.1136 42.529 894.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.97742 .09346 -.09907 2.09607 42.6 894.859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.88076 .25436 -.26962 4.1136 8.528 864.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.97742 .09346 -.09907 2.09607 8.6 864.859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ga",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.99754 .3931 -.41668 6.35739 209.544 818.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.05602 .14444 -.1531 3.23937 209.655 818.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.70313 .43935 -.4657 7.10532 479.549 709.395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.41556 .16143 -.17111 3.62048 479.674 709.393)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ge",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.28948 .73995 -.78434 11.96682 575.083 975.139)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.7525 .27188 -.2882 6.09764 575.294 975.136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.46711 .55496 -.58826 8.97514 609.062 1041.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22E0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#22E0FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22E0FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#22E0FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#22E0FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.31438 .2039 -.21614 4.57324 609.22 1041.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C4F7FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1F6FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#87EEFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#83EEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58E8FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#22E0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#22E0FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#22E0FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1728v1728H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceStars);
export default __webpack_public_path__ + "static/media/space-stars.17838937dcd84baed773f8f3b888a028.svg";
export { ForwardRef as ReactComponent };